import { Action, Permission, Group } from "types";
import getCurrentUser from "lib/auth/pca";

class GroupsHelper {
  #convertActionToPermissions(selectedActions: Action[]): any {
    const currentUser = getCurrentUser();
    return (
      selectedActions?.map((action: Action): Permission => {
        const permission: Permission = {
          userCreation: currentUser,
          groupID: 0,
          actionID: action.actionID,
          dateCreation: new Date(),
          actionDescription: action.description,
        };
        return permission;
      }) || []
    );
  }
  getActionsFromGroup(groups: Group): any {
    return groups?.permissions?.map((action: Permission) => action.actionDescription) || [];
  }

  convertFormDataToGroup(values: any, groupId: number, selectedActions: Action[]): Group {
    const currentUser = getCurrentUser();
    const permissions = this.#convertActionToPermissions(selectedActions);
    const convertedGroup: Group = {
      permissions,
      name: values.name,
      description: values.description,
      userCreation: currentUser, //TODO: change this value with auth info
      groupID: groupId || 0,
      dateCreation: new Date(),
      updatedBy: currentUser,
      updatedDate: new Date(),
    };
    return convertedGroup;
  }
}
const helper = new GroupsHelper();
export default helper;
